import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.css'],
})
export class DynamicTableComponent {
  @Input() tableTitle = '';
  @Input() totalLabel = 'Total records';
  @Input() tableHeaders: any[] = [];
  @Input() tableColumns: any[] = [];
  @Input() tableData: any;
  @Output() goToPreviousPage = new EventEmitter<void>();
  @Output() goToNextPage = new EventEmitter<void>();

  constructor() {}

  getCellValue(row: any, column: any): any {
    const keys = Array.isArray(column.key) ? column.key : [column.key];

    for (const key of keys) {
      const value = String(key)
        .split('.')
        .reduce((current, part) => current ? current[part] : current, row);

      if (value !== null && value !== undefined && value !== '') {
        return value;
      }
    }

    return null;
  }

  formatCellValue(row: any, column: any): string {
    const value = this.getCellValue(row, column);

    if (value === null) {
      return '-';
    }

    if (column.type === 'seconds') {
      const milliseconds = Number(value);
      return Number.isFinite(milliseconds)
        ? (milliseconds / 1000).toFixed(2)
        : String(value);
    }

    if (column.type === 'number') {
      const numberValue = Number(value);
      return Number.isFinite(numberValue)
        ? numberValue.toLocaleString('en-US')
        : String(value);
    }

    if (column.type === 'date') {
      const date = new Date(value);
      return Number.isNaN(date.getTime())
        ? String(value)
        : date.toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
    }

    return String(value);
  }

  hasCellValue(row: any, column: any): boolean {
    return this.getCellValue(row, column) !== null;
  }

  goToPrevious() {
    this.goToPreviousPage.emit();
  }

  goToNext() {
    this.goToNextPage.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/monitoring/components/dynamic-table/dynamic-table.component.ts